import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-field', 'required', 'Obligāts');
Labels.set('ui-field', 'add', 'Pievienot');
Labels.set('ui-field', 'remove', 'Dzēst');
